











import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import SwapResponsibleDialog from '@/components/Dialogues/SwapResponsibleDialog.vue';
import { Attribute } from '@/interfaces/Attribute';
import StepEnvironmentInput from '@/components/FormElements/StepEnvironmentInput.vue';
import AttributeCategorizedList from '@/components/Attributes/AttributeCategorizedList.vue';
import { Category } from '@/interfaces/Category';
import env from '@/env';
import axios from 'axios';
import { Environment } from '@/interfaces/Environment';
import { CutoverplanHasEnvironment } from '@/interfaces/CutoverplanHasEnvironment';

@Component({
  components: { AttributeCategorizedList, StepEnvironmentInput, SwapResponsibleDialog }
})
export default class EditCutoverplanAttributeTab extends Vue {
  @Prop()
  cutoverplan?: any;

  @Prop()
  attributes?: Attribute[];

  get environments() {
    if (!this.cutoverplan?.environments) {
      return [{ id: null, name: 'DEFAULT' }];
    }
    const environmentsInCutoverplan = this.$store.state.all_environments.filter(
      (environment: Environment) =>
        this.cutoverplan.environments.find(
          (cutoverplanHasEnvironment: CutoverplanHasEnvironment) =>
            environment.id === cutoverplanHasEnvironment.environment_id
        )
    );
    return [{ id: null, name: 'DEFAULT' }, ...environmentsInCutoverplan];
  }

  @Prop()
  selectedEnvironment?: number;

  categories: Category[] = [
    ({
      id: 'null',
      name: 'Ohne Kathegorie'
    } as unknown) as Category
  ];

  @Watch('selectedEnvironment')
  watchSelectedEnvironment(value: number) {
    this.selectEnvironment(value);
  }

  private selectEnvironment(value: number) {
    this.attributes?.forEach((attribute: Attribute) => {
      attribute.selected = value;
    });
  }

  async created() {
    this.selectEnvironment(this.selectedEnvironment || 0);
    const { data: categories } = await axios.get(`${env.backend_url}/attribute/all_categories`);
    this.categories.push(...categories);
  }

  dateMenu = false;
}
